/**
 * API URLs for `fetch`. Production and local webpack dev both use same-origin
 * relative paths (`/api/...`); webpack dev-server proxies `/api` to :3001.
 */
export function resolveLocalDevApiUrl(path: string): string {
  const p = path.startsWith("/") ? path : `/${path || ""}`;
  return p;
}
